//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Service from '@/service'

import Loading from '@/components/views/loading'
import InputDlg from '../_input_dlg'
import WxUsername from '../_wx_username'

import detailSubPage from '@/common/mixins/detailSubPage'
import getUserInfo from '@/common/utils/getUserInfo'

import CommentTip from '@/views/building/_components/comment_tip'
import add_comments from '@/common/mixins/addComments'
import pagination from '@/common/mixins/pagination'

import { getLikeCount } from '@/views/building/comments/utils'
import { App_User } from '@/data/user_info'
export default {
    mixins: [
        pagination,
        add_comments,
        detailSubPage
    ],
    name: 'CommentDetail',
    data () {
        return {
            per: 20,
            title: '',
            comment: {
                is_liked: false,
                like_count: 0
            },
            reply_total_count: 0,
            reply_user: {},
            show_reply: false
        }
    },
    computed: {
        like_count () {
            const { is_liked, like_count } = this.comment
            return getLikeCount(is_liked, like_count)
        }
    },
    mounted () {
        const { name, id } = this.$route.query
        this.title = name
        this.getComment()
    },
    methods: {
        stopClick() {},
        getComment () {
            const { building_id, id } = this.$route.query
            Service.getBuildingCommentDetail(building_id, id).then((data) => {
                this.comment = data
                this.getData()
            })
        },
        getData () {
            this.loading = true
            const { id } = this.$route.query
            Service.getCommentsReply(id, {
                page: this.page,
                per: this.per
            }).then((data) => {
                this.handleData(data)
                this.reply_total_count = data.total_count
            })
        },
        onLike (e) {
            App_User.get().then((data) => {
                if (data.tag_list[0] == "天府通游客") {
                    wx.navigateTo({
                        url: '/logging_in'
                    })
                } else {
                    if (this.liking) {
                        return
                    }
                    this.liking = true
                    const { id } = e.currentTarget.dataset
                    const { comment } = this
                    let method = 'likeComment'
                    if (comment.is_liked) {
                        method = 'delLikedComment'
                    }
                    Service[method](id).then(() => {
                        this.changeLike(!comment.is_liked)
                    })
                }
            })
        },
        changeLike (like) {
            const { comment } = this
            this.comment.is_liked = like
            this.comment.like_count = like ? comment.like_count + 1 : comment.like_count - 1
            this.liking = false
        },
        goReply (e) {
            const { index } = e.currentTarget.dataset
            this.goComment(index)
        },
        async goComment (reply_index) {
            if (await this.$checkUserLogging()) {
                const { building_id } = this.$route.query
                let reply_id = this.comment.id
                if (typeof reply_index === 'number') {
                    reply_id = this.items[reply_index].id
                }
                this.goAddComment(building_id, reply_id).then((can_comment) => {
                    if (can_comment) {
                        this.showReply(reply_index)
                    }
                })
            }
        },
        async showReply (reply_index) {
            if (await this.$checkUserLogging()) {
                this.show_reply = true
                this.reply_user = (reply_index && typeof Number(reply_index) === 'number') ? this.items[reply_index] : {}
            }
        },
        hideReply () {
            this.show_reply = false
        },
        onConsult (id) {
            if (id) {
                wx.navigateTo({
                    url: `/consultants/card/main?id=${id}`
                })
            }
        },
        changeComment (data) {
            const { comment } = this
            this.items.unshift(data)
            this.reply_total_count += 1
            this.hideReply()
        },
        previewImg(e) {
            const { photos_urls } = this.comment
            const current = photos_urls[0]
            wx.previewImage({
                current,
                urls: photos_urls
            })
        }
    },
    components: {
        Loading,
        InputDlg,
        WxUsername,
        CommentTip
    }
}
